import PropTypes from "prop-types";
import { Link } from "../DependencyHelper";
import styles from "./LinkRoute.module.scss";

const LinkRoute = ({ href, text, className, as, id }) => {
  return (
    <Link legacyBehavior href={href} as={as} passHref>
      <a className={`${styles.link} ${className}`} id={id}>{text}</a>
    </Link>
  );
};

LinkRoute.defaultProps = {
  href: "",
  as: "",
  text: "",
  className: ""
};
LinkRoute.propTypes = {
  href: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  as: PropTypes.string,
  text: PropTypes.any,
  className: PropTypes.string,
  id: PropTypes.string,
};

export default LinkRoute;
